const D1 = "https://bawaindustries.com/assets/images/Infographic/BI1.png"
const D2 = "https://bawaindustries.com/assets/images/Infographic/BI2.png"
const D3 = "https://bawaindustries.com/assets/images/Infographic/BI3.png"
const D4 = "https://bawaindustries.com/assets/images/Infographic/BI4.png"
const D5 = "https://bawaindustries.com/assets/images/Infographic/BI5.png"
const D6 = "https://bawaindustries.com/assets/images/Infographic/BI6.png"
const D7 = "https://bawaindustries.com/assets/images/Infographic/BI7.png"
const D8 = "https://bawaindustries.com/assets/images/Infographic/BI8.png"
const D9 = "https://bawaindustries.com/assets/images/Infographic/BI9.png"
const D10 = "https://bawaindustries.com/assets/images/Infographic/BI10.png"

export const col1 = [
	{
		text: "Legacy of over six decades of excellence in production of premium spices and spice blends",
		imgSrc:D1,
	},
	{
		text: "Traditional recipe blends, made even better through constant innovation.",
		imgSrc:D2,
	},
	{
		text: "State-of-art technology with the finest machinery.",
		imgSrc:D3,
	},
	{
		text: "Best manufacturing processes and standard in the industry.",
		imgSrc:D4,
	},
	{
		text: "Premium quality, with an international reputation.",
		imgSrc:D5,
	},
	{
		text: "Fumigation to keep the quality of the product intact and increase shelf life.",
		imgSrc:D6,
	},
	{
		text: "Unparallelled cleaning and processing capacity ",
		imgSrc:D7,
	},
	{
		text: "Best in class marketing support and highly trained sales staff",
		imgSrc:D8,
	},
	{
		text: "Attractive trade schemes for dealers and stockists",
		imgSrc:D9,
	},
	{
		text: "High customer satisfaction, confidence and continuous quality improvement ",
		imgSrc:D10,
	}
]



// WEBPACK FOOTER //
// ./src/constant/legacyConstant.js